<template>
    <b-modal ref="mdlAccettazioneSsnGruppi" :title="title" centered no-close-on-backdrop no-close-on-esc
        hide-header-close size="lg" ok-title="Salva" cancel-title="Annulla" @ok="onOkMdlAccettazioneSsnGruppi"
        :ok-disabled="!isValidazioneOK">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Nome</label>
                <b-form-input v-model="jsonData.nome" :class="{ 'fs-not-valid-input': !isValid('NOME') }"
                    maxlength="100"></b-form-input>
                <small v-if="!isValid('NOME')" class="text-danger" style="margin-left:10px">Campo obbligatorio</small>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Proprietario</label>
                <b-form-input v-model="jsonData.proprietario"
                    :class="{ 'fs-not-valid-input': !isValid('PROPRIETARIO') }"></b-form-input>
                <small v-if="!isValid('PROPRIETARIO')" class="text-danger" style="margin-left:10px">Campo
                    obbligatorio</small>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Descrizione</label>
                <b-form-input v-model="jsonData.descrizione"
                    :class="{ 'fs-not-valid-input': !isValid('DESCRIZIONE') }"></b-form-input>
                <small v-if="!isValid('DESCRIZIONE')" class="text-danger" style="margin-left:10px">Campo
                    obbligatorio</small>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <b-form-textarea v-model="jsonData.note" rows="3" max-rows="6"></b-form-textarea>
            </b-col>
        </b-row>
        <b-row v-if="jsonData.id" class="mt-3">
            <b-col cols="12" md="6">
                <small class="text-muted">Creato da {{ jsonData.createUser }} il {{ formatDataOra(jsonData.createDate)
                }}</small>
            </b-col>
            <b-col cols="12" md="6" class="text-md-right">
                <small class="text-muted">Modificato da {{ jsonData.updateUser }} il {{
                    formatDataOra(jsonData.updateDate) }}</small>
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>
import moment from "moment";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import toast from "../../../../template/layout/utility/sa-toast.js";

export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    data() {
        return {
            title: null,
            pathResource: "/accettazionessngruppi",
            jsonData: this.getEmptyJsonData(),
        };
    },
    computed: {
        isValidazioneOK() {
            return this.validazione().esito;
        },
    },
    methods: {
        getEmptyJsonData() {
            return {
                id: null,
                nome: "",
                descrizione: "",
                note: "",
                proprietario: "",
            };
        },
        show(item) {
            if (item?.id) {
                this.title = "Modifica Gruppo";
                this.jsonData = { ...this.getEmptyJsonData(), ...JSON.parse(JSON.stringify(item)) };
                // la colonna "note" è NOT NULL: evito null
                if (this.jsonData.note == null) this.jsonData.note = "";
            } else {
                this.title = "Nuovo Gruppo";
                this.jsonData = this.getEmptyJsonData();
            }
            this.$refs.mdlAccettazioneSsnGruppi.show();
        },
        hide() {
            this.$refs.mdlAccettazioneSsnGruppi.hide();
        },
        isEmpty(value) {
            return value == null || String(value).trim() === "";
        },
        isValid(element) {
            switch (element) {
                case "NOME":
                    return !this.isEmpty(this.jsonData.nome);
                case "DESCRIZIONE":
                    return !this.isEmpty(this.jsonData.descrizione);
                case "PROPRIETARIO":
                    return !this.isEmpty(this.jsonData.proprietario);
                default:
                    return true;
            }
        },
        validazione() {
            let esito = true;
            let msg = "";
            if (!this.isValid("NOME")) {
                msg += "Nome non valido! #";
                esito = false;
            }
            if (!this.isValid("DESCRIZIONE")) {
                msg += "Descrizione non valida! #";
                esito = false;
            }
            if (!this.isValid("PROPRIETARIO")) {
                msg += "Proprietario non valido! #";
                esito = false;
            }
            return { esito: esito, msg: msg };
        },
        formatDataOra(value) {
            return value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
        },
        onOkMdlAccettazioneSsnGruppi(bvModalEvent) {
            let me = this;
            bvModalEvent.preventDefault();
            let validation = me.validazione();
            if (!validation.esito) {
                toast.validation(validation);
                return;
            }
            if (me.jsonData.note == null) me.jsonData.note = "";
            me.openShowModalLoading();
            me.$emit("beforeSave");
            me.saveResource(me.pathResource, me.jsonData, me.saveResourceSuccess, me.saveResourceError);
        },
        saveResourceSuccess() {
            this.hide();
            this.closeShowModalLoading();
            this.$emit("afterSave");
            this.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveResourceError(error) {
            this.closeShowModalLoading();
            let message = error?.response?.data?.messaggio || "Errore durante il salvataggio";
            this.$bvToast.toast(message, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
<style>
.fs-not-valid-input {
    border: 1px solid red !important;
}
</style>
